import { IExternalContactSubmit, IExternalContacts } from 'entities';
import {
  inferTypeFromContactValue,
  isExternalContactTypeConsistent,
  normalizeTypeContact,
  resolveExternalContactType,
  sanitizeContactValueForType,
} from './externalContactType';

/**
 * Valida se um contato externo é válido para ser enviado ao backend.
 */
export const isValidExternalContact = (contact: IExternalContacts): boolean => {
  if (!contact.isVerified) return false;
  if (!contact.isValid) return false;
  if (contact.alreadyExists) return false;

  const type = normalizeTypeContact(contact.type);
  const rawValue = contact.value?.trim() ?? '';
  if (contact.isEmpty || !rawValue) return false;

  const sanitizedValue = sanitizeContactValueForType(type, rawValue);
  if (!sanitizedValue) return false;

  return isExternalContactTypeConsistent(type, sanitizedValue);
};

/**
 * Normaliza type e value antes do envio ao backend.
 */
export const prepareExternalContactForSubmit = (
  contact: IExternalContacts,
): IExternalContactSubmit => {
  const rawValue = contact.value?.trim() ?? '';
  const type = resolveExternalContactType(contact.type, rawValue);
  const value = sanitizeContactValueForType(type, rawValue);

  return {
    id: contact.id,
    isVerified: contact.isVerified,
    createdById: contact.createdById,
    type,
    value,
  };
};

export const prepareExternalContactsForSubmit = (
  contacts: IExternalContacts[],
): IExternalContactSubmit[] =>
  contacts.filter(isValidExternalContact).map(prepareExternalContactForSubmit);

/**
 * Normaliza contatos vindos da API para o estado do formulário.
 */
export const normalizeExternalContactFromApi = (
  contact: IExternalContacts,
): IExternalContacts => {
  const value = contact.value ?? '';
  const type = resolveExternalContactType(contact.type, value);
  const sanitizedValue = sanitizeContactValueForType(type, value);

  return {
    ...contact,
    type,
    value: sanitizedValue,
    isEmpty: !sanitizedValue,
    isValid: inferTypeFromContactValue(sanitizedValue) !== null,
  };
};
